import { getColorIfAlias } from "common/themes/base";

export const toHex = function(color) {
    const match = getColorIfAlias(color);
    if (match) return match;
    
    return `#${`0${Number.parseInt(color[0], 10).toString(16)}`.slice(-2)}${`0${Number.parseInt(color[1], 10).toString(16)}`.slice(-2)}${`0${Number.parseInt(color[2], 10).toString(16)}`.slice(-2)}`.toUpperCase();
};

/**
 * Handle color operations by leveraging Highcharts.Color utility
 * @param {String} color The input color in rbga, hex, or word format (e.g. `green`)
 * @returns {*|{get, brighten, rgba, setOpacity, raw}}
 */

const addLight = function(color, amount) {
    const cc = Number.parseInt(color, 16) + amount;
    let c = cc > 255 ? 255 : cc;
    c = c.toString(16).length > 1 ? c.toString(16) : `0${c.toString(16)}`;
    return c;
};

export const lighten = (color, amount) => {
    color = color.includes("#") ? color.substring(1, color.length) : color;
    amount = Number.parseInt((255 * amount) / 100, 10);
    return `#${addLight(color.substring(0, 2), amount)}${addLight(color.substring(2, 4), amount)}${addLight(color.substring(4, 6), amount)}`;
};

const subtractLight = function(color, amount) {
    const cc = Number.parseInt(color, 16) - amount;
    let c = cc < 0 ? 0 : cc;
    c = c.toString(16).length > 1 ? c.toString(16) : `0${c.toString(16)}`;
    return c;
};

export const darken = (color, amount) => {
    color = color.includes("#") ? color.substring(1, color.length) : color;
    amount = Number.parseInt((255 * amount) / 100, 10);
    return `#${subtractLight(color.substring(0, 2), amount)}${subtractLight(color.substring(2, 4), amount)}${subtractLight(color.substring(4, 6), amount)}`;
};

/**
 * Returns one hex value from among a range of three different values.
 * @param {number} rangeIndex The index that corresponds to the desired hex value.
 * @returns {string} A hex value (e.g. `#ff33ac`)
 */
export const getRangeColor = (rangeIndex) => [toHex("wcag-blue"), toHex("paz-black-l-30"), toHex("wcag-yellow")][rangeIndex];
